import * as React from 'react';
type Props = {
  className?: string;
};
export function ArrowLeft({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-arrow-left"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6569 6.34314L13.0711 7.75735L9.829 10.9991L18 11V13L9.828 12.9991L13.0711 16.2426L11.6569 17.6568L7.41421 13.4142L6 12L11.6569 6.34314Z"
        fill="currentColor"
      />
    </svg>
  );
}
